var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column text-uppercase font-weight-thin subtitle-2"},[_c('span',[_vm._v("CM ADMIN")])])
}]

export { render, staticRenderFns }